var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popupmessage",class:{
    popupmessagegreen: ['confirmed', 'success'].includes(_vm.message.type),
    popupmessageblue: _vm.message.type == 'info',
    popupmessageyellow: _vm.message.type == 'warning',
    popupmessagered: _vm.message.type == 'error',
  }},[_c('div',{staticClass:"popupmessage__icon"},[_c('img',{attrs:{"src":['confirmed', 'success'].includes(_vm.message.type)
          ? 'img/check.png'
          : _vm.message.type == 'error'
          ? 'img/error.png'
          : _vm.message.type == 'warning'
          ? 'img/warning.png'
          : 'img/info.png'}})]),_c('div',{staticClass:"popupmessage__content"},[_c('p',{staticClass:"popupmessage__type"},[_vm._v(_vm._s(_vm.message.header))]),_c('p',{staticClass:"popupmessage__message"},[_vm._v(_vm._s(_vm.message.description))])])])}
var staticRenderFns = []

export { render, staticRenderFns }